import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-h6 text-center text-wrap mb-2" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-center ga-1 mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center pa-8"
}
const _hoisted_5 = { class: "text-caption text-center text-medium-emphasis mb-2" }
const _hoisted_6 = { class: "pa-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-body-2 mb-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis" }, " El calendario es abierto: queda con tu rival y, al jugar, meted el resultado aquí. Puedes cambiar de lista antes de cada partida desde Mis eventos. ", -1)
const _hoisted_9 = { class: "text-subtitle-1 font-weight-bold mt-3" }
const _hoisted_10 = {
  key: 1,
  class: "text-medium-emphasis my-2"
}
const _hoisted_11 = { class: "text-subtitle-1 font-weight-bold mt-4" }
const _hoisted_12 = { class: "pa-2" }

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";
import { computed, onMounted, ref } from "vue";
import { Torneo } from "@/interfaces/Torneo";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { InscripcionUsuarioIndividualDTO } from "@/interfaces/Inscripcion";
import { getPartidasTorneo } from "@/services/TorneosService";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";
import {
  generarClasificacionLiga,
  partidaJugada,
} from "@/utils/clasificacionLiga";
import TabMostrarListas from "@/components/GestionTorneos/TabMostrarListas.vue";
import TabJornadasLiga from "@/components/GestionTorneos/Liga/TabJornadasLiga.vue";
import TablaClasificacionLiga from "@/components/GestionTorneos/Liga/TablaClasificacionLiga.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LigaEnVivo',
  props: {
    torneo: {},
    idUsuario: {}
  },
  setup(__props: any) {

const props = __props;
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => props.torneo.classificationType);

const isLoading = ref(true);
const partidas = ref<PartidaTorneoDTO[]>([]);
const inscripciones = ref<InscripcionUsuarioIndividualDTO[]>([]);
const tab = ref("jornadas");

const cuenta = (n: number, singular: string, plural: string) =>
  `${n} ${n === 1 ? singular : plural}`;

const jornadas = computed(() =>
  partidas.value.reduce((max, p) => Math.max(max, p.numeroRonda), 0)
);
const jugadas = computed(() => partidas.value.filter(partidaJugada).length);

const esMia = (p: PartidaTorneoDTO) =>
  props.idUsuario !== undefined &&
  (p.idUsuario1 === props.idUsuario || p.idUsuario2 === props.idUsuario);
const mias = computed(() =>
  partidas.value
    .filter(esMia)
    .sort((a, b) => a.numeroRonda - b.numeroRonda)
);
const juega = computed(() => mias.value.length > 0);
const misPendientes = computed(() =>
  mias.value.filter(p => !partidaJugada(p))
);
const misJugadas = computed(() => mias.value.filter(partidaJugada));
const miEjercito = computed(
  () =>
    inscripciones.value.find(i => i.idUsuario === props.idUsuario)
      ?.ejercitoElegido
);

const clasificacion = computed(() =>
  generarClasificacionLiga(
    partidas.value,
    inscripciones.value,
    props.torneo.classificationType
  )
);

// Mientras no la haya validado, puede meter o corregir el resultado
function faltaMiValidacion(p: PartidaTorneoDTO) {
  if (p.idUsuario1 === props.idUsuario) return p.partidaValidadaUsuario1 !== true;
  return p.partidaValidadaUsuario2 !== true;
}

// Si el rival ya lo metió, solo le queda validarlo
function soloFaltaMiValidacion(p: PartidaTorneoDTO) {
  if (p.idUsuario1 === props.idUsuario)
    return p.partidaValidadaUsuario1 !== true && p.partidaValidadaUsuario2 === true;
  return p.partidaValidadaUsuario2 !== true && p.partidaValidadaUsuario1 === true;
}

onMounted(async () => {
  const [respPartidas, respInscripciones] = await Promise.allSettled([
    getPartidasTorneo(props.torneo.idTorneo),
    getInscripcionesTorneo(props.torneo.idTorneo),
  ]);
  if (respPartidas.status === "fulfilled")
    partidas.value = respPartidas.value.data;
  if (respInscripciones.status === "fulfilled")
    inscripciones.value = respInscripciones.value.data;
  // Quien juega la liga entra directo a sus partidas
  if (juega.value) tab.value = "mias";
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.torneo.nombreTorneo), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_chip, {
        size: "small",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Liga")
        ]),
        _: 1
      }),
      _createVNode(_component_v_chip, { size: "small" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.torneo.idaYVuelta ? "Ida y vuelta" : "Solo ida"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_chip, { size: "small" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.torneo.cuentaElo ? "Cuenta para el ELO" : "No cuenta para el ELO"), 1)
        ]),
        _: 1
      })
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (partidas.value.length === 0)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            variant: "tonal",
            class: "ma-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" La liga aún no tiene jornadas. El organizador las genera cuando cierra las inscripciones. ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(cuenta(jornadas.value, "jornada", "jornadas")) + " · " + _toDisplayString(jugadas.value) + " de " + _toDisplayString(cuenta(partidas.value.length, "partida", "partidas")) + " jugadas ", 1),
            _createVNode(_component_v_tabs, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              "show-arrows": "",
              grow: ""
            }, {
              default: _withCtx(() => [
                (juega.value)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      value: "mias"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mis partidas")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_tab, { value: "jornadas" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Jornadas")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "clasificacion" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Clasificación")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "listas" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Listas")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_window, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
            }, {
              default: _withCtx(() => [
                (juega.value)
                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                      key: 0,
                      value: "mias"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          (miEjercito.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                _createTextVNode(" Juegas con "),
                                _createElementVNode("strong", null, _toDisplayString(miEjercito.value), 1),
                                _createTextVNode(". ")
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_8,
                          _createElementVNode("h3", _hoisted_9, " Pendientes (" + _toDisplayString(misPendientes.value.length) + ") ", 1),
                          (misPendientes.value.length === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Has jugado todas tus partidas. "))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(misPendientes.value, (partida) => {
                            return (_openBlock(), _createBlock(CardPartidaGestion, {
                              key: partida.idPartidaTorneo,
                              partida: partida,
                              editable: false,
                              etiqueta: `Jornada ${partida.numeroRonda}`,
                              idJugador: _ctx.idUsuario!,
                              meterResultado: faltaMiValidacion(partida),
                              soloValidar: soloFaltaMiValidacion(partida)
                            }, null, 8, ["partida", "etiqueta", "idJugador", "meterResultado", "soloValidar"]))
                          }), 128)),
                          (misJugadas.value.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("h3", _hoisted_11, " Jugadas (" + _toDisplayString(misJugadas.value.length) + ") ", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(misJugadas.value, (partida) => {
                                  return (_openBlock(), _createBlock(CardPartidaGestion, {
                                    key: partida.idPartidaTorneo,
                                    partida: partida,
                                    editable: false,
                                    etiqueta: `Jornada ${partida.numeroRonda}`,
                                    idJugador: _ctx.idUsuario!
                                  }, null, 8, ["partida", "etiqueta", "idJugador"]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_window_item, { value: "jornadas" }, {
                  default: _withCtx(() => [
                    _createVNode(TabJornadasLiga, {
                      partidas: partidas.value,
                      jornadas: jornadas.value,
                      editable: false
                    }, null, 8, ["partidas", "jornadas"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "clasificacion" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      (_ctx.torneo.mostrarClasificacion)
                        ? (_openBlock(), _createBlock(TablaClasificacionLiga, {
                            key: 0,
                            filas: clasificacion.value,
                            idUsuario: _ctx.idUsuario
                          }, null, 8, ["filas", "idUsuario"]))
                        : (_openBlock(), _createBlock(_component_v_alert, {
                            key: 1,
                            type: "info",
                            variant: "tonal",
                            class: "ma-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" La clasificación está oculta. ")
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "listas" }, {
                  default: _withCtx(() => [
                    (_ctx.torneo.mostrarListas)
                      ? (_openBlock(), _createBlock(TabMostrarListas, {
                          key: 0,
                          torneo: _ctx.torneo
                        }, null, 8, ["torneo"]))
                      : (_openBlock(), _createBlock(_component_v_alert, {
                          key: 1,
                          type: "info",
                          variant: "tonal",
                          class: "ma-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Las listas están ocultas. ")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
  ]))
}
}

})